import { Plug, CreditCard, FlaskConical, CheckCircle2, XCircle } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

// Honest status markers for not-yet-live areas. i18n-driven, tenant-neutral (light-theme cockpit).
const KINDS = {
  not_configured:        { tone: "warn", icon: Plug,         label: "marker.not_configured" },
  gateway_not_connected: { tone: "warn", icon: CreditCard,   label: "marker.gateway_not_connected" },
  database_only:         { tone: "warn", icon: CreditCard,   label: "marker.database_only" },
  demo:                  { tone: "warn", icon: FlaskConical, label: "marker.demo" },
  synthetic:             { tone: "info", icon: FlaskConical, label: "marker.synthetic" },
  connected:             { tone: "ok",   icon: CheckCircle2, label: "marker.connected" },
  error:                 { tone: "err",  icon: XCircle,      label: "marker.error" },
};
const TONE = {
  ok:   { bg: "rgba(16,185,129,0.12)", fg: "#15803D", bd: "rgba(16,185,129,0.35)" },
  warn: { bg: "rgba(245,158,11,0.12)", fg: "#B45309", bd: "rgba(245,158,11,0.35)" },
  info: { bg: "rgba(59,130,246,0.12)", fg: "#1D4ED8", bd: "rgba(59,130,246,0.35)" },
  err:  { bg: "rgba(239,68,68,0.12)",  fg: "#B91C1C", bd: "rgba(239,68,68,0.35)" },
};

export function StatusMarker({ kind, className = "", testid }) {
  const { t } = useI18n();
  const k = KINDS[kind] || KINDS.not_configured;
  const tn = TONE[k.tone];
  const Icon = k.icon;
  return (
    <span
      data-testid={testid || `status-marker-${kind}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold ${className}`}
      style={{ background: tn.bg, color: tn.fg, borderColor: tn.bd }}
    >
      <Icon className="h-3.5 w-3.5" /> {t(k.label)}
    </span>
  );
}
